import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {
    AddIcon,
    Button,
    ButtonIcon,
    ButtonSpinner,
    ButtonText,
    CheckIcon,
    ExternalIcon,
    HStack
} from "@hosttools/frontend";
import {type AccountType} from "@hosttools/frontend/models/account";
import {type Listing} from "@hosttools/frontend/models/listing";
import {type FC, memo, useCallback} from "react";

import ConnectChannelItemLabel from "../ConnectChannelItemLabel";

interface Props {
    listing: Listing;
    accountType: AccountType;
    isConnected: boolean;
    isDisabled?: boolean;
    isLoading?: boolean;
    className?: string;
    onToggleChannel: (listing: Listing, accountType: AccountType, isConnected: boolean) => void;
}

const containerStyle = tva({
    base: "justify-between px-4 py-4"
});

const ChannelItem: FC<Props> = ({
    listing,
    accountType,
    isConnected,
    isDisabled,
    isLoading,
    className,
    onToggleChannel
}) => {
    const handlePress = useCallback(async () => {
        onToggleChannel(listing, accountType, isConnected);
    }, [listing, accountType, isConnected, onToggleChannel]);

    return (
        <HStack
            className={containerStyle({
                className
            })}
        >
            <ConnectChannelItemLabel accountType={accountType} />
            <HStack className="items-center">
                {accountType === "ChannelConnector" ? (
                    <Button isDisabled={isDisabled} variant="outline" onPress={handlePress}>
                        {isLoading && <ButtonSpinner />}
                        <ButtonIcon as={isConnected ? ExternalIcon : AddIcon} />
                        <ButtonText>{isConnected ? "Open" : "Connect account"}</ButtonText>
                    </Button>
                ) : (
                    <Button isDisabled={isDisabled} variant="outline" onPress={handlePress}>
                        {isLoading && <ButtonSpinner />}
                        <ButtonIcon as={isConnected ? CheckIcon : AddIcon} />
                        <ButtonText>{isConnected ? "Connected" : "Connect account"}</ButtonText>
                    </Button>
                )}
            </HStack>
        </HStack>
    );
};

export default memo(ChannelItem);
